import { render, staticRenderFns } from "./CalendarioFestivos.vue?vue&type=template&id=2364a16a&"
import script from "./CalendarioFestivos.vue?vue&type=script&lang=js&"
export * from "./CalendarioFestivos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports